<template>
  <section class="news-section list__mod">
    <header-inner/>
    <wrapper :line-borders="false" :line-center="true">
      <menu-news @currentMenu="currentMenu($event)"></menu-news>
      <section  v-if="entitiesLoaded">
        <div class="title-main"><h1  v-html="this.social.title"></h1></div>
        <!-- Big one -->
        <news-Big-slide  v-if="mainImage"
                       :image="this.social.image_detailed ? this.social.image_detailed : mainImage.image"
                       :buttonShow="false"
                       class="big-slide"
        ><span v-html="this.social.text"></span>
        </news-Big-slide >

        <!-- Two related -->
        <card-news-small v-if="entities" v-for="(item) in entities" :key="item.id"
                         :title="item.title"
                         :image="item.image"
                         :id="item.id"
                         :link="item.url"
                         :date="item.date"
                         :linkTo="'/news/social/'+ item.id"
                         :text="item.text"
        ></card-news-small>
      </section>
    </wrapper>
  </section>

</template>

<script>
  import HeaderInner from '../../components/header/HeaderInner'

  import CardNewsBig from '../../components/shared/cards/CardNewsBig'
  import CardNewsSmall from '../../components/shared/cards/CardNewsSmall'
  import DateMixin from '../../components/shared/mixins/DateMixin.js'

 // import Slider from "../../components/shared/sliders/Slider";
  import NewsBigSlide from "../../components/shared/sliders/NewsBigSlide";
  import StringMixin from "../../components/shared/mixins/StringMixin";
  import MenuNews from "../../components/news/MenuNews";
  import ContentText from "../../components/shared/content/ContentText";



  export default {
    async asyncData({ $axios, app, route, redirect, store, query }) {
      await Promise.all([
        store.dispatch('content/loadTitle', 'social'),
        store.dispatch('content/loadEntities', { sID: 'social' })
      ]);
      let seoPage = {}
      try {
        seoPage = await $axios.$get(`${process.env.apiUrl}/methods/site/get_page_info/?link=${route.path}`,
                {
                  timeout: 1000 * 5, // Wait for 5 seconds
                }
        );
        return {seoPage}
      } catch (e) {
        seoPage = {id:  '', title: '', description: '', keywords: ''}
        return {seoPage};
      }
    },
    data() {
      return {
        mainImage: {
          id:1001,
          image: 'https://new.russoutdoor.ru//upload/iblock/d9b/1568-a.jpg',
          linkRef: 'http://vse-ravno.net/',
          text:'Компания уделяет большое внимание социальным проектам, направленным на привлечение внимания жителей \n' +
            'к социальным проблемам. Мы создаем социальную рекламу и предоставляем существеный объём рекламных поверхностей под её размещение.\n' +
            'Социальный проект “Всё равно?” — инициатива крупнейшего оператора наружной рекламы Russ Outdoor совместно \n' +
            'с рекламными агентствами, которые помогают проекту разработать и подготовить макеты. Цель проекта — \n' +
            'не оставаться равнодушными и не бездействовать, сталкиваясь с социальными проблемами. Мы искренне убеждены \n' +
            'в том, что каждый человек может внести свой вклад для того, чтобы наш мир менялся к лучшему.',
        },
        seoMenu: {
          title: null,
          description: null,
          keywords: null,
        }
      };
    },
    head () {
      if(this.seoPage) {
        return {
          title: this.seoPage.title,
          link: [{rel: 'canonical', href: process.env.base + this.$route.path}],
          meta: [
            {
              hid: `description`,
              name: `description`,
              content: this.seoPage.description
            },
            {
              hid: `keywords`,
              name: 'keywords',
              content: this.seoPage.keywords
            }
          ]
        }
      }
    },
    components: {
      HeaderInner,
      CardNewsBig,
      CardNewsSmall,
    //  Slider,
      NewsBigSlide,
      MenuNews,
      ContentText
    },
    mixins: [DateMixin,StringMixin],

    computed: {
      social() {
        return this.$store.state.content.titles.social;
      },
      entitiesLoaded() {
        return this.$store.state.content.entities.social.loaded;
      },
      entities() {
        return this.$store.state.content.entities.social.items;
      },


      // slidesLoaded() {
      //     return this.$store.state.content.entities.world.loaded;
      // },
      // slides() {
      //     return this.$store.state.content.entities.world.items;
      // },

    },
    methods: {
      currentMenu(event) {
        //this.seoMenu.title = event.title
        //this.seoMenu.description = event.description
        //this.seoMenu.keywords = event.keywords
      }
    },
    mounted() {
      // this.$store.dispatch('content/loadTitle', 'social');
      // this.$store.dispatch('content/loadEntities', { sID: 'social' });
    },
    watch: {
      slides() {
        this.$refs.slider.rebuild();
      },
    },

  };
</script>

<style lang="scss" scoped>
  @import "../../assets/vars", "../../assets/mixins";

</style>



// WEBPACK FOOTER //
// pages/news/social.vue